<template>
  <div class="404 full-page-width relative">
    <h1 class="info">{{ $t('page_not_found') }}</h1>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  created() {
    this.$router.push('/login')
  },
}
</script>
